module.exports = __webpack_public_path__ + "img/md5-normal2.a417fd1e.png";